import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import MaintenancePage from "./Components/Maintenance/MaintenancePage";
import { QuickCommerceProvider } from "./Components/User/context/QuickCommerceProvider";
import { MAINTENANCE_MODE } from "./config/maintenance";
import "./index.css";
import { persistor, store } from "./redux/store/store";
import reportWebVitals from "./reportWebVitals";
import { registerServiceWorker } from "./registerServiceWorker";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://aa278215ed5f66d6fe1466673f520383@o4509651585007616.ingest.us.sentry.io/4509654949625856",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const root = ReactDOM.createRoot(document.getElementById("root"));

const fullApp = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <QuickCommerceProvider>
          <App />
        </QuickCommerceProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

const maintenanceShell = (
  <BrowserRouter>
    <Routes>
      <Route path="*" element={<MaintenancePage />} />
    </Routes>
  </BrowserRouter>
);

root.render(
  <StrictMode>
    {MAINTENANCE_MODE ? maintenanceShell : fullApp}
  </StrictMode>,
);

registerServiceWorker()
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
